import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import UIButton from 'UIComponents/button/UIButton';
import UIButtonWrapper from 'UIComponents/layout/UIButtonWrapper';
import UIPanelSection from 'UIComponents/panel/UIPanelSection';
import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import { useTrackEvent } from 'automation-ui-usage-tracking/usageTrackingHooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NewEnrollmentsAlert = ({
  fetchNewEnrollments,
  flowObjectTypeId
}) => {
  const trackEvent = useTrackEvent();
  return /*#__PURE__*/_jsx(UIPanelSection, {
    className: "p-top-0",
    children: /*#__PURE__*/_jsx(UIAlert, {
      type: "info",
      children: /*#__PURE__*/_jsxs(UIButtonWrapper, {
        children: [/*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
          baseLangKey: "automation.enrollmentHistory.panel.enrollment-list.newEnrollmentsAlert.title_cob",
          objectTypeId: flowObjectTypeId
        }), /*#__PURE__*/_jsx(UIButton, {
          size: "xs",
          use: "tertiary",
          onClick: () => {
            trackEvent(Trackables.CLICK_VIEW_NEW_ENROLLMENTS);
            fetchNewEnrollments();
          },
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation.enrollmentHistory.panel.enrollment-list.newEnrollmentsAlert.buttonText"
          })
        })]
      })
    })
  });
};
export default NewEnrollmentsAlert;